/**
 * Puts focus on the page's content area. For a control that is about to
 * disappear when pressed: without this, focus falls back to the document and
 * a keyboard user starts again from the top.
 */
export function focusMain() {
  document.getElementById('main')?.focus({ preventScroll: true })
}
